<template>
    <div v-if="inputOptions.length == 0" class="template-dropdown-number-widget">
        <NumberWidget class="no-border" v-model="selectedNumber" @input="onSelectedNumber"></NumberWidget>
        <div class="widget-divider"></div>
        <DropdownWidget class="no-border" v-model="selectedValue" :options="options" @input="onSelectedValue">
        </DropdownWidget>
    </div>
    <div v-else class="template-dropdown-milt-number-widget">
        <div v-for="(item, index) in value" :key="index" class="temp-input-widget">
            <div class="input-label">{{ item.type }}</div>
            <NumberWidget :value="getNumberValue(item.value)" @input="onSelectedNumber($event, item.type)"></NumberWidget>
        </div>
        <DropdownWidget class="no-border" v-model="selectedValue" :options="options" @input="onSelectedValue">
        </DropdownWidget>
    </div>
</template>
<script>
import { eventBus } from "@/main";
import DropdownWidget from "./dropdown_widget.vue"
import NumberWidget from "./number_widget.vue";
export default {
    name: "editor-property",
    components: {
        DropdownWidget,
        NumberWidget
    },
    props: {
        value: {
            type: [String, Array],
            default: "",
        },
        options: {
            type: Array,
            default: () => [],
            required: true,
        },
        inputOptions: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            selectedNumber: 0,
            selectedValue: 'px'
        };
    },
    watch: {
        value: function (val) {
            let vm = this;
            vm.initiateValue(vm.value);
        },
    },
    mounted() {
        let vm = this;
        vm.initiateValue(vm.value);
    },
    methods: {
        getNumberValue(value) {
            const [number, unit] = value.match(/(\d+)(\D+)/).slice(1);
            return parseInt(number);
        },
        initiateValue(value) {
            let vm = this;
            if (vm.inputOptions.length == 0) {
                if (value.match(/(\d+)(\D+)/)) {
                    const [number, unit] = value.match(/(\d+)(\D+)/).slice(1);
                    this.selectedNumber = parseInt(number);
                    this.selectedValue = unit;
                }
            } else {
                if (vm.value[0].value.match(/(\d+)(\D+)/)) {
                    const [number, unit] = vm.value[0].value.match(/(\d+)(\D+)/).slice(1);
                    this.selectedValue = unit;
                }
            }
        },
        onSelectedNumber(value, type = null) {
            let vm = this;
            if (vm.inputOptions.length == 0) {
                vm.$emit("input", vm.selectedNumber + vm.selectedValue);
            } else {
                const data = vm.inputOptions.map(item => {
                    if (item == type) {
                        return {
                            type: item,
                            value: value + vm.selectedValue
                        }
                    } else {
                        const numberValue = vm.getNumberValue(vm.value.find(it => it.type == item).value);
                        return {
                            type: item,
                            value: numberValue + vm.selectedValue
                        }
                    }
                })
                this.$emit("input", data);
            }
        },
        onSelectedValue(value) {
            let vm = this;
            if (vm.inputOptions.length == 0) {
                this.$emit("input", this.selectedNumber + this.selectedValue);
            } else {
                const data = vm.inputOptions.map(item => {
                    const numberValue = vm.getNumberValue(vm.value.find(it => it.type == item).value);
                    return {
                        type: item,
                        value: numberValue + vm.selectedValue
                    }
                })
                this.$emit("input", data);
            }
        },
    },
};
</script>
  
<style lang="scss" scoped>
$assets: "~@/assets";

.template-dropdown-number-widget {
    display: flex;
    position: relative;
    width: max-content;
    background-color: #ffffff;
    border-radius: 5px;
    border: 1px solid #e9e9e9;
}

.template-dropdown-milt-number-widget {
    display: flex;
    align-items: flex-end;
    position: relative;
    width: max-content;
    border-radius: 5px;

    .temp-input-widget {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-right: 5px;

        .input-label {
            font-size: 8px;
        }
    }
}
</style>